module.exports = __webpack_public_path__ + "static/img/icon_achievement_title.6e992a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_achievement_title.png
// module id = mysG
// module chunks = 1